import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CasinoLoadingDialog } from './casinoLoading.dialog';

@Injectable()
export class CasinoLoadingService {
  private dialogRef;

  constructor(private _MatDialog: MatDialog) {}

  open() {
    this.dialogRef = this._MatDialog.open(CasinoLoadingDialog, {
      id: 'loadingCasino',
      width: '350px',
      minHeight: '35vh',
      panelClass: 'loadingDialog',
      disableClose: true,
      closeOnNavigation: true,
    });
  }

  close() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
